import { render, staticRenderFns } from "./VersionsList.vue?vue&type=template&id=4fda20cd"
import script from "./VersionsList.vue?vue&type=script&lang=js"
export * from "./VersionsList.vue?vue&type=script&lang=js"
import style0 from "./VersionsList.vue?vue&type=style&index=0&id=4fda20cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports